import { useNavigate } from "react-router";
import React, { useEffect, useState } from "react";
import { faRefresh } from "@insidebeehive/fortawesome/pro-regular-svg-icons/faRefresh";

import { Body } from "./page";
import TextCopyTool from "./text-copy-tool";

import { Button } from "../ui/button";
import { Icon } from "../ui/icon";
import { Flex } from "../ui/flex";

import disconnect from "~/assets/error/disconnect.png";

const ErrorPage = (props: { title: string | undefined; message: string | undefined; requestId: string | undefined }) => {
  const [error, setError] = useState({
    error: props?.title || "Unknown Error",
    status: 500,
    statusText: props?.message || "Internal server error occurred!",
    errorId: "",
  });
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate("/login");
  };
  const reload = () => {
    navigate(0);
  };

  useEffect(() => {
    setError({
      error: "Unknown Error",
      status: 500,
      statusText: "Internal server error occurred!",
      errorId: props?.requestId || "",
    });
  }, [props]);

  return (
    <div className="flex flex-col h-full w-screen md:w-full">
      <Body>
        <Flex justifyContent="center" alignItems="center" className="h-[calc(100vh-2rem)] md:h-screen pb-10 md:pb-0 overflow-auto md:overflow-clip">
          <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28">
            <div className="xl:pt-0 w-full h-full xl:w-2/3 relative pb-12 lg:pb-0">
              <div className="relative">
                <div className="absolute">
                  <div className="w-full px-4 md:px-0">
                    <h1 className="mt-2 text-gray-800 font-extrabold text-2xl">{error?.error}</h1>
                    <span className="font-bold text-error">
                      {error?.statusText} {error?.errorId && <TextCopyTool children={error?.errorId} />}
                    </span>
                    <p className="mt-6 mb-4 text-secondary-foreground font-extralight space-x-2">
                      Sorry about that! Please try reloading or visit our homepage to get where you need to go.
                      {/* <Link to="/support" className="text-red-700 ml-1 hover:underline">Raise issue?</Link> */}
                    </p>
                    <Flex gap={2} alignItems="center">
                      <Button onClick={navigateToHome}>Take me there!</Button>
                      <div onClick={reload}>
                        <Icon icon={faRefresh} name="refresh-regular" onClick={reload} className="cursor-pointer" />
                      </div>
                    </Flex>
                  </div>
                </div>
                <div className="w-full h-full bottom-20">
                  <p className="md:text-[12rem] text-[8rem] font-extrabold text-gray-100">{error?.status}</p>
                </div>
              </div>
            </div>
            <div className="w-full h-full px-2">
              <img loading="lazy" alt="background" src={disconnect} />
            </div>
          </div>
        </Flex>
      </Body>
    </div>
  );
};

export default ErrorPage;
